import { render, staticRenderFns } from "./WaitingModal.vue?vue&type=template&id=b57bd2ae&"
import script from "./WaitingModal.vue?vue&type=script&lang=js&"
export * from "./WaitingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports